import { render, staticRenderFns } from "./ItemListSearchlistLayout.vue?vue&type=template&id=1c72b3db&scoped=true"
import script from "./ItemListSearchlistLayout.vue?vue&type=script&lang=js"
export * from "./ItemListSearchlistLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72b3db",
  null
  
)

export default component.exports